import Card from "@/atoms/CardKeyWorkers";
import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";
import GameChanger from "@/public/cutomers-reviews/gamechangers.svg?url";
import Rewarding from "@/public/cutomers-reviews/rewarding.svg?url";
import UserFriendly from "@/public/cutomers-reviews/user-friendly.svg?url";

const KeyWorkers = (): JSX.Element => {
  return (
    <section className="px-4 pt-5 md:pt-20 pb-9 bg-white md:px-6 lg:px-0">
      <h3 className="mb-11 text-4xl font-bold lg:text-5xl text-landing-blue md:mb-3 lg:mb-14 xt-left text-center">
        According to our customers, we are:
      </h3>

      <div className="block lg:h-[384px] lg:flex lg:flex-row lg:justify-center lg:mb-10">
        <Card
          title="Gamechangers"
          size="middle"
          image={GameChanger}
          footer={"Emma, Liverpool"}
          subtitle={"“Their whole approach has restored our faith in the whole property market”"}
        />

        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block " />

        <Card
          title="User friendly"
          size="middle"
          image={UserFriendly}
          footer={"Aimee, Isleworth"}
          subtitle={"“Professional with clear communication throughout the process”"}
        />
        <HorizontalBar className="inline-block my-4 lg:hidden" />
        <VerticalBar className="hidden lg:inline-block" />

        <Card
          title="Rewarding"
          size="middle"
          image={Rewarding}
          footer={"James, Liverpool"}
          subtitle={"“Highly recommend anyone who is struggling to save a deposit”"}
        />
        {/* <HorizontalBar className="inline-block my-4 lg:hidden" /> */}
      </div>
    </section>
  );
};

export default KeyWorkers;
